const ListItemSwipeable = () => {
    throw new Error("ListItemSwipeable is not currently supported for web. ");
};
export default ListItemSwipeable;
